module.exports = __webpack_public_path__ + "img/icon-cursor.4d077a95.svg";